import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var BackToTop = function BackToTop(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 14 29' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5062029,13.4816194 L7,7.71305517 L1.49379707,13.4816194 C1.15168276,13.8400349 0.598700041,13.8400349 0.256585732,13.4816194 C-0.0855285772,13.1232039 -0.0855285772,12.5438725 0.256585732,12.185457 L6.38139433,5.76881161 C6.72350864,5.41039613 7.27649136,5.41039613 7.61860567,5.76881161 L13.7434143,12.185457 C14.0855286,12.5438725 14.0855286,13.1232039 13.7434143,13.4816194 C13.5727946,13.6603688 13.3488016,13.7502018 13.1248086,13.7502018 C12.9008156,13.7502018 12.6768226,13.6603688 12.5062029,13.4816194 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,27.0763288 L6,6.92367117 C6,6.41380469 6.448,6 7,6 C7.552,6 8,6.41380469 8,6.92367117 L8,27.0763288 C8,27.587119 7.552,28 7,28 C6.448,28 6,27.587119 6,27.0763288 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "14",
    height: "2",
    rx: "1"
  }));
};

BackToTop.displayName = 'BackToTop';
export default BackToTop;